import info from '@amo/core/assets/images/icons/infos_conducteur.png';
import { Question } from '@amo/core/components/containers';
import { LargeSpinner } from '@amo/core/components/loaders';
import { validateImmatriculation } from '@amo/core/utils/validateField';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import {
    Civilite,
    Nom,
    Prenom,
    NomNaissance,
    VilleNaissance,
    PaysNaissance,
    InformationEntreprise
} from '@amo/core/components/questions';

const InformationsSouscripteur = (props) => {
    const { data, postSaveDevis, saveDevisLoading, source } = props;
    const IndexSouscripteur = _.includes(['true', '1', true], _.get(data, 'DemandeTarif[ListePersonnes][1][Souscripteur]')) ? 1 : 0;
    const [tryPost, setTryPost] = useState(false);
    const motifAvenant = _.get(data, 'DemandeTarif[Police][MotifAvenant]')
    /* Édition de l'identité (civilité/nom/prénom) réservée au conseiller : les motifs 5/8/10/11 sont exclusivement conseiller,
       mais le form hérite du motif de l'init, donc un courtier reprenant un tel avenant pourrait sinon éditer le nom du client */
    const identiteEditable = source === 'conseiller' && ['5', '8', '10', '11'].includes(motifAvenant)
    const requiredPaysNaissance = _.get(data, 'titulaireCarteGrise') !== '2' && motifAvenant === '5';

    useEffect(() => {
        if (tryPost) {
            isNotValid();
        }
    }, [data, tryPost]);

    /* Function qui ajoute la class error sur les champs vide */
    const handleError = (fieldName, remove) => {
        if (document.getElementsByName(fieldName).length > 0) {
            _.forEach(document.getElementsByName(fieldName), (input) => {
                if (input.getAttribute('type') === 'radio') {
                    if (remove) {
                        input.labels[0].classList.remove('error');
                    } else {
                        input.labels[0].classList.add('error');
                    }
                } else {
                    if (remove) {
                        input.classList.remove('error');
                    } else {
                        input.classList.add('error');
                    }
                }
            });
        } else {
            /* Gestion des autocomplete */
            if (remove) {
                document.querySelectorAll(`[data-name='${fieldName}']`)[0]?.classList.remove('error');
            } else {
                document.querySelectorAll(`[data-name='${fieldName}']`)[0]?.classList.add('error');
            }
        }
    };
    
    const isNotValid = () => {
        let notValid = false;
        let fields = [
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Civilite]`
                : `DemandeTarif[ListePersonnes][1][Nom]`,
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Nom]`
                : `DemandeTarif[ListePersonnes][1][LegalStatus]`,
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Prenom]`
                : '',
            IndexSouscripteur !== 0 ? `DemandeTarif[ListePersonnes][0][Civilite]` : '',
            IndexSouscripteur !== 0 ? `DemandeTarif[ListePersonnes][0][Nom]` : '',
            IndexSouscripteur !== 0 ? `DemandeTarif[ListePersonnes][0][Prenom]` : '',
        ];

        if(requiredPaysNaissance) {
            fields.push(`DemandeTarif[ListePersonnes][${IndexSouscripteur}][BirthCountry]`)
            fields.push(`DemandeTarif[ListePersonnes][${IndexSouscripteur}][BirthCity]`)

            if(IndexSouscripteur !== 0) {
                fields.push('DemandeTarif[ListePersonnes][0][BirthCountry]')
                fields.push('DemandeTarif[ListePersonnes][0][BirthCity]')
            }
        }

        fields.forEach((field) => {
            if (!_.get(data, field) && field !== '') {
                handleError(field);
                notValid = true;
            } else {
                handleError(field, true);
            }
        });

        if (_.get(data, 'immatriculation_check') !== '0') {
            if (validateImmatriculation(_.get(data, 'DemandeTarif[Vehicule][Immatriculation]'))) {
                notValid = true;
            }
        }

        return notValid;
    };

    /* Envoie d'une fonction de validation  */

    const myPostSaveDevis = async () => {
        setTryPost(true);
        if (isNotValid()) {
            document.getElementsByClassName('error')[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            postSaveDevis();
        }
    };

    return (
        <>
            {saveDevisLoading ? (
                <LargeSpinner message={"Nous enregistrons votre proposition d'assurance"} />
            ) : (
                <div id={'etape-informations'} className={'fade-in'}>
                    <Question
                        loader
                        icon={info}
                        title={IndexSouscripteur !== 0 ? 'Coordonnées du souscripteur' : 'Vos coordonnées'}
                    >
                        {_.get(data, 'titulaireCarteGrise') !== '2' ? (
                            <>
                                <Civilite {...props} index={IndexSouscripteur} disabled={!identiteEditable}/>
                                <Nom {...props} index={IndexSouscripteur} disabled={!identiteEditable}/>
                                <NomNaissance {...props} index={IndexSouscripteur} />
                                <Prenom {...props} index={IndexSouscripteur} disabled={!identiteEditable}/>
                                <PaysNaissance {...props} index={IndexSouscripteur} required={requiredPaysNaissance} />
                                <VilleNaissance {...props} index={IndexSouscripteur} required={requiredPaysNaissance} />
                            </>
                        ) : (
                            <>
                                <InformationEntreprise {...props} />
                            </>
                        )}
                    </Question>

                    {(IndexSouscripteur !== 0  || _.get(data, 'titulaireCarteGrise') === '2') && (
                        <Question icon={info} title={'Coordonnées du conducteur'} loader>
                            <Civilite {...props} index={0} disabled={!identiteEditable}/>
                            <Nom {...props} index={0} disabled={!identiteEditable}/>
                            <NomNaissance {...props} index={0} />
                            <Prenom {...props} index={0} disabled={!identiteEditable}/>
                            <PaysNaissance {...props} index={0} required={requiredPaysNaissance} />
                            <VilleNaissance {...props} index={0} required={requiredPaysNaissance} />
                        </Question>
                    )}
                    
                    <button className={`btn btn-primary btn-arrow mt-4`} onClick={() => myPostSaveDevis()}>
                        {_.get(data, 'typeDevis') === 'subscribe' ? 'Continuer' : 'Recevoir ma proposition'}
                    </button>
                </div>
            )}
        </>
    );
};

export default InformationsSouscripteur;
